import MaintenanceList from "./MaintenanceList";
import BuildIcon from "@material-ui/icons/Build";

const Maintenance = {
    list: MaintenanceList,
    icon: BuildIcon
};

export default Maintenance;
